import { useContext } from "react";
import { AuthContext } from "@/components/auth/AuthProvider";
import { ImpersonationContext } from "@/contexts/ImpersonationContext";
import type { OrgUser, OrgUserRole } from "@/types/firestore";

export function useAuth() {
  const context = useContext(AuthContext);
  if (!context) {
    throw new Error("useAuth must be used within an AuthProvider");
  }

  const impersonation = useContext(ImpersonationContext);

  // When impersonating, override role and orgUser for downstream consumption
  if (impersonation?.isImpersonating && impersonation.orgId && context.orgUser &&
      (context.role === "PLATFORM_OWNER" || context.role === "PLATFORM_ADMIN")) {
    const syntheticOrgUser: OrgUser = {
      ...context.orgUser,
      role: "ORG_OWNER" as OrgUserRole,
      orgId: impersonation.orgId,
    };
    return {
      ...context,
      orgUser: syntheticOrgUser,
      role: "ORG_OWNER" as OrgUserRole,
      realRole: context.role,
      realOrgUser: context.orgUser,
      isImpersonating: true,
    };
  }

  return {
    ...context,
    realRole: context.role,
    realOrgUser: context.orgUser,
    isImpersonating: false,
  };
}
